var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _path, _line, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path2, _ellipse, _ellipse2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRSadNoResultsFoundStamp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 174,
    viewBox: "0 0 133 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.8464,
    y: 45.1616,
    width: 86.6082,
    height: 128.365,
    rx: 4.25602,
    fill: "white",
    stroke: "#E52333",
    strokeWidth: 0.945783
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.184,
    y: 150.229,
    width: 10.4684,
    height: 2.85245,
    fill: "#E52333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.972892,
    y: 0.472892,
    width: 105.642,
    height: 154.988,
    rx: 8.03916,
    fill: "white",
    stroke: "#E52333",
    strokeWidth: 0.945783
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7271,
    y: 17.115,
    width: 75.1822,
    height: 2.85245,
    fill: "#E52333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7271,
    y: 27.5737,
    width: 74.2305,
    height: 3.80327,
    fill: "#E52333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7241,
    y: 40.748,
    width: 16.6509,
    height: 4.15897,
    fill: "#E52333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.6338,
    y: 40.748,
    width: 8.32543,
    height: 4.15897,
    fill: "#E52333"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.6905,
    y: 21.4604,
    width: 91.495,
    height: 91.4301
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.79px)",
      clipPath: "url(#bgblur_0_117_1645_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_117_1645)",
    "data-figma-bg-blur-radius": 9.58393
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.438,
    cy: 67.1754,
    rx: 36.1636,
    ry: 36.1311,
    fill: "white",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8721 67.5082C91.8721 86.4165 76.5296 101.748 57.6001 101.748C38.6706 101.748 23.3281 86.4165 23.3281 67.5082C23.3281 48.5998 38.6706 33.2686 57.6001 33.2686C76.5296 33.2686 91.8721 48.5998 91.8721 67.5082Z",
    stroke: "#E52333",
    strokeWidth: 3.78313
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.36446,
    x2: 14.1407,
    y2: -2.36446,
    transform: "matrix(0.673004 0.739639 -0.740241 0.672342 81.3921 94.1312)",
    stroke: "#E52333",
    strokeWidth: 4.72892
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107.087,
    y: 138.819,
    width: 8.56506,
    height: 3.80327,
    fill: "#E52333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7749,
    y: 135.967,
    width: 76.1339,
    height: 2.85245,
    fill: "#E52333"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7271,
    y: 125.508,
    width: 74.2305,
    height: 3.80327,
    fill: "#E52333"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7271,
    y: 114.098,
    width: 74.2305,
    height: 3.80327,
    fill: "#E52333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7749,
    y: 103.64,
    width: 27.5985,
    height: 2.85245,
    fill: "#E52333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 107.087,
    y: 59.9011,
    width: 8.56506,
    height: 3.80327,
    fill: "#E52333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 107.087,
    y: 71.3112,
    width: 8.56506,
    height: 2.85245,
    fill: "#E52333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.996 127.786C130.036 130.973 129.914 136.019 126.725 139.056C123.535 142.093 118.485 141.972 115.445 138.785L89.7515 111.85C86.7115 108.663 86.8327 103.618 90.0223 100.581C93.2119 97.5436 98.2619 97.6649 101.302 100.852L126.996 127.786Z",
    fill: "#E52333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.7044,
    cy: 58.4753,
    rx: 3.33086,
    ry: 3.32786,
    fill: "#E52333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.4959,
    cy: 66.082,
    rx: 3.33086,
    ry: 3.32786,
    fill: "#E52333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.827 88.134C64.6856 87.8667 65.1762 86.9555 64.845 86.1202C63.978 83.9333 62.7044 81.9292 61.0862 80.2151C59.0971 78.108 56.641 76.4962 53.91 75.5056C51.179 74.515 48.2471 74.1725 45.3436 74.5049C42.974 74.7761 40.6757 75.4909 38.5675 76.6068C37.7774 77.025 37.5593 78.0308 38.0378 78.7853C38.5207 79.5466 39.5285 79.7615 40.3334 79.3547C42.0037 78.5105 43.8111 77.9669 45.6718 77.7539C48.0733 77.479 50.4982 77.7623 52.757 78.5816C55.0158 79.401 57.0473 80.7341 58.6925 82.4769C59.9579 83.8172 60.9684 85.3719 61.6809 87.066C62.0351 87.9082 62.9541 88.4057 63.827 88.134Z",
    fill: "#E52333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_117_1645",
    x: 11.6905,
    y: 21.4604,
    width: 91.495,
    height: 91.4301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.79197,
    dy: 4.79197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_117_1645"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.79197,
    dy: -4.79197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_117_1645",
    result: "effect2_innerShadow_117_1645"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_117_1645_clip_path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-11.6905 -21.4604)",
    cx: 57.438,
    cy: 67.1754,
    rx: 36.1636,
    ry: 36.1311
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRSadNoResultsFoundStamp);
export default __webpack_public_path__ + "static/media/r-sad-no-results-found-stamp.5f4dedb186f1b36018f7ab1941609eef.svg";
export { ForwardRef as ReactComponent };